<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <span>机构特色</span>
      </div>
      <div>
        <span>是否展示：</span>
        <el-switch v-model="resAllSow"
                   @change="AllstartChange()"
                   active-color="#0b8586">
        </el-switch>
      </div>
    </div>
    <div class="addbox">
      <div style="display: flex;align-items: center;cursor: pointer;"
           @click="toadd()">
        <img src="../../assets/img/icon/jia2.png"
             style="height:17px;"
             alt="">
        <span style="color:#0b8586;">新增</span>
      </div>
      <span>新增资源上限为6条</span>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>标题</th>
            <th style="width:150px">图片（封面）</th>
            <th style="width:80px">类型</th>
            <th style="position: relative;width:160px">
              <span class="paixutop">排序</span>
              <span class="paixuspan">(值越大越靠前)</span>
            </th>
            <th style="width:80px">状态</th>
            <th style="width:100px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in storeList"
              :key="index">
            <td>{{ item.title }}</td>
            <td>
              <img :src="item.coverPicture"
                   class="tbImage"
                   v-show="item.coverPicture"
                   alt="">
              <span v-show="item.coverPicture==''">无封面</span>
            </td>
            <td>{{ item.o_type==1?'图片':'视频' }}</td>
            <td>
              <span v-show="updateSortId!=item.id"
                    style="cursor: pointer;color:#0B8586;"
                    @click="updateSortId=item.id;updateSort=item.sort">{{item.sort}}</span>
              <input v-if="updateSortId==item.id"
                     class="timeInput"
                     @blur="changeSort(item.id)"
                     v-model="updateSort"
                     v-myfocus
                     type="text">
            </td>
            <td>
              <!-- <el-switch v-model="item.is_Start"
                         active-color="#13ce66"
                         @change="startChange(item.is_Start,item.id)"
                         inactive-color="#ff4949">
              </el-switch> -->
              <span>{{item.is_Start==true?'上架':'下架'}}</span>
            </td>
            <td>
              <img style="margin-right:10px;cursor: pointer;"
                   src="../../assets/img/icon/bianji.png"
                   @click="toUpdataResources(item.id)"
                   alt="" />
              <el-popconfirm title="您确定要删除吗？"
                             @confirm="toDeleteResources(item.id)">
                <img src="../../assets/img/icon/shanchu.png"
                     style="cursor: pointer;"
                     slot="reference"
                     alt="" />
              </el-popconfirm>
            </td>
          </tr>
          <tr v-show="storeList.length < 1">
            <td colspan="6">暂无图文信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-dialog :visible.sync="isadd"
               :before-close="toClose"
               class="add"
               width="660px">
      <div class="addtop3">
        <span>标题：</span>
        <el-input placeholder="请输入标题"
                  v-model="title"
                  style="width:494px"
                  clearable>
        </el-input>
      </div>
      <div class="addtop4">
        <span>简介：</span>
        <imageEditer class="addjianjie"
                     :changeText="changeText"
                     ref="imageEditer"
                     :jianjie="jianjie"></imageEditer>
      </div>
      <div class="addtop1">
        <span>类型：</span>
        <el-radio-group v-model="resType"
                        style="margin-left:10px">
          <el-radio :label="1">图片</el-radio>
          <el-radio :label="2">视频</el-radio>
        </el-radio-group>
      </div>
      <div class="addtop4">
        <span>{{resType==1?'图片':'封面'}}：</span>
        <webupload fileaccept=".jpg,.jpeg,.png"
                   :Maxfileszie="3"
                   :uploadtype="2"
                   :orgid="orgid"
                   :onSuccess="handleSuccess"
                   :before-upload="beforeAvatarUpload">
          <div class="addImg">
            <span v-show="!CoverPicture"
                  style="font-weight: 100;font-size: 40px;">+</span>
            <span v-show="!CoverPicture">图片上传</span>
            <img v-show="CoverPicture"
                 :src="CoverPicture"
                 alt="">
          </div>
        </webupload>
      </div>
      <span class="addtop2"
            style="margin-left:43px">支持jpg、jpeg、png格式；图片小于2M；图片比例670*378</span>
      <div class="addtop4"
           v-if="resType==2">
        <span>视频：</span>
        <webupload fileaccept=".mp4"
                   :Maxfileszie="1024"
                   :uploadtype="2"
                   :orgid="orgid"
                   class="addt4box"
                   :onSuccess="handleSuccess2">
          <div class="addmp4box"
               v-show="!resUrl">
            <img src="../../assets/img/icon/import.png"
                 alt="">
            <span>上传视频</span>
          </div>
          <div v-show="resUrl"
               class="mp4box">
            <video :src="resUrl"
                   controls="controls"
                   @click.stop></video>
            <!-- <el-button type="danger"
                       icon="el-icon-refresh"
                       style="margin-left:20px;margin-top:-10px"
                       size="mini">重新上传</el-button> -->
            <span>重新上传</span>
          </div>
        </webupload>
      </div>
      <div class="addtop1">
        <span>是否上架：</span>
        <el-switch v-model="resSow"
                   active-color="#0b8586">
        </el-switch>
      </div>
      <div class="addtop5">
        <div @click="ToSub">
          <span>保存</span>
        </div>
        <div style="background: #BDC1C1;"
             @click="isadd=false">
          <span>取消</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import webupload from '../../components/webupload/webupload.vue';
import imageEditer from '../../components/imageEditer';
export default {
  name: 'usInfor',
  components: {
    webupload,
    imageEditer
  },
  data () {
    return {
      storeName: '',
      storeList: [],
      orgid: 0,
      isadd: false,
      title: '',
      id: 0,
      uid: 0,
      isfabu: false,
      resType: 1,
      resSow: true,
      resAllSow: true,
      updateSortId: 0,
      updateSort: '',
      CoverPicture: '',
      resId: 0,
      resUrl: '',
      jianjie: '',
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id)
    this.GetMyStoreList()
    this.GetAllstart()
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess (response) {
      this.CoverPicture = response.ossfileurl;
    },
    handleSuccess2 (response) {
      this.resId = response.resid;
      this.resUrl = response.ossfileurl
    },
    GetMyStoreList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetOrgfeatureList', {
          orgId: this.orgid,
          page: 1,
          limit: 30
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data;
          }
        });
    },
    GetAllstart () {
      this.httphelper
        .get('/api/EnterpriseApi/GetOrgConfigById', {
          orgId: this.orgid
        })
        .then(res => {
          if (res.code == 200) {
            this.resAllSow = res.data.is_Orgfeature
          }
        });
    },
    toadd () {
      if (this.storeList.length >= 6) {
        return this.$message({
          message: '最多可上传六条资源',
          type: 'warning'
        });
      } else {
        this.isadd = true
      }
    },
    ToSub () {
      if (this.title == '') {
        return this.$message({
          message: '标题不能为空',
          type: 'warning'
        });
      } else if (this.jianjie == '') {
        return this.$message({
          message: '简介不能为空',
          type: 'warning'
        });
      } else if (this.resType == 1 && this.CoverPicture == '') {
        return this.$message({
          message: '请上传图片',
          type: 'warning'
        });
      } else if (this.resType == 2 && this.resId == 0) {
        return this.$message({
          message: '请上传视频',
          type: 'warning'
        });
      }
      this.httphelper
        .post('/api/EnterpriseApi/SaveGporgfeature', {
          id: this.id,
          title: this.title,
          resId: this.resId,
          o_type: this.resType,
          o_content: this.jianjie,
          coverPicture: this.CoverPicture,
          orgId: this.orgid,
          Is_Start: this.resSow,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            if (this.id == 0) {
              this.$message({
                message: '新增成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
            }
            this.toClose()
          }
        });
    },
    toDeleteResources (id) {
      this.httphelper
        .post('/api/EnterpriseApi/DelOrgfeatureById', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        });
    },
    toUpdataResources (id) {
      this.httphelper
        .get('/api/EnterpriseApi/GetOrgfeatureById', {
          id: id
        })
        .then(res => {
          if (res.code == 200) {
            this.id = res.data.id
            this.title = res.data.title
            this.resType = res.data.o_type
            this.resSow = res.data.is_Start
            this.CoverPicture = res.data.coverPicture
            this.jianjie = res.data.o_content
            if (this.resType == 2) {
              this.resId = res.data.resId
              this.resUrl = res.data.res_Url
            }
            var test1 = setTimeout(() => {
              this.$refs.imageEditer.toText()
              clearTimeout(test1);
            }, 300);
            this.isadd = true
          }
        });
    },
    AllstartChange () {
      this.httphelper.post('/api/EnterpriseApi/UpdOrgfeatureShow', {
        id: this.orgid,
        status: this.resAllSow
      })
        .then(res => {
          if (res.data.code == 200) {
            if (this.resAllSow == true) this.$message.success('上架成功');
            if (this.resAllSow == false) this.$message.success('下架成功');
          }
        });
    },
    toClose () {
      this.title = ''
      this.resId = 0
      this.resType = 1
      this.resUrl = ''
      this.CoverPicture = ''
      this.id = 0
      this.jianjie = ''
      this.$refs.imageEditer.clear()
      this.resSow = true
      this.isadd = false
    },
    startChange (status, id) {
      this.httphelper.post('/api/EnterProjectApi/EnterProjectStart', {
        id: id,
        status: status
      })
        .then(res => {
          if (res.data.code == 200) {
            if (status == true) this.$message.success('上架成功');
            if (status == false) this.$message.success('下架成功');
          }
        });
    },
    changeSort (id) {
      this.httphelper.post('/api/EnterpriseApi/UpdOrgfeatureSort', {
        id: id,
        sort: Number(this.updateSort)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.updateSortId = 0;
            this.$message.success('更改排序成功');
          }
        });
    },
    changeText (e) {
      this.jianjie = e;
    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    padding-right: 20px;
    margin: 30px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.ttleft {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
}
.ttright {
    width: 100px;
    height: 30px;
    background: #0b8586;
    border: 1px solid #0b8586;
    border-radius: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 55px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.addbox {
    margin: 20px 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.addbox span {
    margin-left: 10px;
}
.tbImage {
    width: 65px;
    height: 45px;
}
.add ::v-deep .el-dialog__body {
    padding: 27px 57px 65px 57px;
}
.addImg {
    width: 160px;
    height: 104px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a8a8a8;
    align-items: center;
    justify-content: space-around;
}
.addImg img {
    width: 160px;
    height: 104px;
    border-radius: 5px;
    cursor: pointer;
}
.addtop2 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 56px;
    margin-bottom: 6px;
}
.addtop3 {
    display: flex;
    align-items: center;
}
.addtop1 {
    height: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.addtop4 {
    display: flex;
    align-items: flex-start;
    margin-top: 15px;
}
.addtop5 {
    margin-top: 50px;
    display: flex;
    justify-content: center;
}
.addtop5 div {
    width: 165px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    margin: 0 5px;
    color: #ffffff;
    cursor: pointer;
}
.addtop1 ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #0b8586 !important;
}
.addtop1 ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background: #0b8586 !important;
    border-color: #0b8586 !important;
}
.addmp4box {
    width: 113px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    padding: 0 13px;
    box-sizing: border-box;
    cursor: pointer;
}
.mp4box video {
    max-width: 200px;
    max-height: 200px;
}
.mp4box span {
    margin-left: 10px;
    color: rgb(199, 25, 25);
}
.paixuspan {
    position: absolute;
    width: 100px;
    text-align: center;
    font-size: 12px;
    transform: scale(0.85);
    top: 30px;
    left: 30px;
    /* color: #c92929; */
}
.paixutop {
    position: absolute;
    top: 13px;
    left: 67px;
}
.addjianjie {
    width: 494px;
    height: 210px;
}
.addjianjie ::v-deep .w-e-text-container {
    height: 130px !important;
}
.addjianjie ::v-deep .w-e-text {
    min-height: 130px !important;
}
</style>